import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { pad } from '@/lib/format'

import { PRINCIPLES } from '@/constants/agency'

interface PrinciplesListProps {
    tone?: 'light' | 'dark'
    large?: boolean
    className?: string
}

const PrinciplesList: FC<PrinciplesListProps> = ({ tone = 'light', large = false, className }): ReactNode => {
    const dark = tone === 'dark'

    return (
        <ol className={cn('border-t', dark ? 'border-cream/25' : 'border-charcoal', className)}>
            {PRINCIPLES.map((principle, index) => (
                <li
                    key={principle.title}
                    data-reveal
                    className={cn('grid grid-cols-[3rem_1fr] gap-4 border-b py-6 md:grid-cols-[4rem_1fr] md:py-8', dark ? 'border-cream/15' : 'border-charcoal/25')}
                >
                    <span className={cn('font-mono text-xs', dark ? 'text-coral' : 'text-charcoal/75')}>{pad(index + 1)}</span>
                    <div>
                        <h3 className={cn('font-heading font-wide font-black uppercase tracking-[-0.015em]', large ? 'text-[clamp(1.3rem,2vw,1.85rem)] leading-[1]' : 'text-lg md:text-xl')}>
                            {principle.title}
                        </h3>
                        <p className={cn('mt-2 max-w-md text-[15px] leading-relaxed', dark ? 'text-cream/80' : 'text-charcoal/80')}>
                            {principle.description}
                        </p>
                    </div>
                </li>
            ))}
        </ol>
    )
}

export default PrinciplesList
